import React, { useEffect } from "react";
import Header from "../sections/Header";
import Hero from "../sections/Hero";
import Stats from "../sections/Stats";
import Services from "../sections/Services";
import About from "../sections/About";
import Sectors from "../sections/Sectors";
import Partners from "../sections/Partners";
import Threats from "../sections/Threats";
import Contact from "../sections/Contact";
import Footer from "../sections/Footer";

export default function Landing() {
  // Reveal-on-scroll
  useEffect(() => {
    const els = document.querySelectorAll(".reveal:not(.in)");
    if (!("IntersectionObserver" in window)) {
      els.forEach((el) => el.classList.add("in"));
      return;
    }
    const io = new IntersectionObserver(
      (entries) => {
        entries.forEach((e) => {
          if (e.isIntersecting) {
            e.target.classList.add("in");
            io.unobserve(e.target);
          }
        });
      },
      { threshold: 0.12 }
    );
    els.forEach((el) => io.observe(el));
    return () => io.disconnect();
  }, []);

  return (
    <div className="min-h-screen" data-testid="landing-page">
      <Header />
      <Hero />
      <Stats />
      <Services />
      <About />
      <Sectors />
      <Partners />
      <Threats />
      <Contact />
      <Footer />
    </div>
  );
}
